<template>
  <svg viewBox="0 0 640 640" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M129.3 105.6C131.9 99.8 137.6 96 144 96L472 96C494.1 96 512 113.9 512 136L512 208C512 216.8 504.8 224 496 224C487.2 224 480 216.8 480 208L480 136C480 131.6 476.4 128 472 128L180.5 128L347.8 309.1C353.5 315.2 353.5 324.7 347.8 330.8L180.5 512L472 512C476.4 512 480 508.4 480 504L480 432C480 423.2 487.2 416 496 416C504.8 416 512 423.2 512 432L512 504C512 526.1 494.1 544 472 544L144 544C137.6 544 131.9 540.2 129.3 534.4C126.7 528.6 127.9 521.8 132.2 517.1L314.2 320L132.2 122.9C127.9 118.2 126.8 111.4 129.3 105.6z"
      fill="currentColor"
    />
  </svg>
</template>
